import { render, staticRenderFns } from "./paper_detail.vue?vue&type=template&id=42ac16c0&scoped=true&"
import script from "./paper_detail.vue?vue&type=script&lang=js&"
export * from "./paper_detail.vue?vue&type=script&lang=js&"
import style0 from "./paper_detail.vue?vue&type=style&index=0&id=42ac16c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ac16c0",
  null
  
)

export default component.exports